import axios from "axios";
import { logout } from "../lib/auth";
import { productTableColumn } from "../config/product";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 商材一覧
export async function getProducts(props: { [key: string]: number | string }) {
  try {
    const path = "products";
    const params = makeParams(productTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const products: dataDifine[] = response.data.fetch_data;
    const countProducts: string = response.data.count_data;
    return { products, countProducts };
  } catch (error) {
    // logout();
  }
}

// 商材詳細
export async function getProduct(id: string) {
  try {
    const path = "product";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// 商材編集
export async function putProduct(editData: EditDataDifine) {
  try {
    const path = "product";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 商材・支払方法登録
export async function postProduct(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "product";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 商材の取扱い停止・再開
export async function putProductNoEntryFlg(id: string, startStop: string) {
  try {
    const path = "product/noEntryFlg";
    const params = { id };
    const bodys = { id, startStop };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}
